import { render, staticRenderFns } from "./ArchiveTabEvents.vue?vue&type=template&id=7b1c803e"
import script from "./ArchiveTabEvents.vue?vue&type=script&lang=js"
export * from "./ArchiveTabEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports